import { render, staticRenderFns } from "./creatMerchant.vue?vue&type=template&id=750b69bd&scoped=true"
import script from "./creatMerchant.vue?vue&type=script&lang=js"
export * from "./creatMerchant.vue?vue&type=script&lang=js"
import style0 from "./creatMerchant.vue?vue&type=style&index=0&id=750b69bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b69bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750b69bd')) {
      api.createRecord('750b69bd', component.options)
    } else {
      api.reload('750b69bd', component.options)
    }
    module.hot.accept("./creatMerchant.vue?vue&type=template&id=750b69bd&scoped=true", function () {
      api.rerender('750b69bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/list/creatMerchant.vue"
export default component.exports